import * as React from "react";
import { useState, useMemo } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import Events from "./Events";
import Dashboards from "./Dashboards";
import Logs from "./Logs";
import Searches from "./Searches";
import { Container, Row } from "../styled.components";
const EVIDENCE_MAP = {
  events: {
    id: "events",
    label: "Events",
    count: 0,
    component: (investigation) => /* @__PURE__ */ React.createElement(Events, { key: investigation.id, investigation })
  },
  dashboards: {
    id: "dashboards",
    label: "Dashboards",
    count: 0,
    component: (investigation) => /* @__PURE__ */ React.createElement(Dashboards, { investigation })
  },
  logs: {
    id: "logs",
    label: "Logs",
    count: 0,
    component: (investigation) => /* @__PURE__ */ React.createElement(Logs, { investigation })
  },
  searches: {
    id: "searches",
    label: "Searches",
    count: 0,
    component: (investigation) => /* @__PURE__ */ React.createElement(Searches, { investigation })
  }
};
const getEvidenceCount = (investigation, evidenceId) => {
  var _a, _b;
  if (evidenceId === "events") {
    return (_a = investigation.events_count) != null ? _a : investigation.events.length;
  }
  if (evidenceId === "logs") {
    return (_b = investigation.logs_count) != null ? _b : investigation.logs.length;
  }
  return investigation[evidenceId].length;
};
const NavTab = styled.span(
  ({ $active, theme }) => css`
    cursor: pointer;
    color: ${$active ? `${theme.colors.text.primary}` : "grey"};
    padding-bottom: 5px;
    border-bottom: 1px solid ${$active ? `${theme.colors.button.primary.background}` : "transparent"};

    &:hover {
      color: ${theme.colors.text.primary};
    }
  `
);
function Evidence({ investigation }) {
  var _a;
  const { t } = useTranslation("enterprise_security_investigations");
  const [evidenceId, setEvidenceId] = useState();
  const sortedEvidence = useMemo(() => {
    const auxSorted = Object.values(EVIDENCE_MAP).map((evidence) => ({
      ...evidence,
      count: getEvidenceCount(investigation, evidence.id)
    })).sort((a, b) => {
      const aIsEmpty = a.count === 0;
      const bIsEmpty = b.count === 0;
      if (aIsEmpty !== bIsEmpty) {
        return Number(aIsEmpty) - Number(bIsEmpty);
      }
      return a.id.localeCompare(b.id);
    });
    if (!evidenceId) setEvidenceId(auxSorted[0].id);
    return auxSorted;
  }, [investigation, evidenceId]);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement("h4", null, t("drawer_evidence.title")), /* @__PURE__ */ React.createElement(Row, { $gap: "0.4rem" }, sortedEvidence.map((evidence) => /* @__PURE__ */ React.createElement(NavTab, { key: evidence.id, onClick: () => setEvidenceId(evidence.id), $active: evidenceId === evidence.id }, evidence.label, " ", evidence.count > 0 && `(${evidence.count})`))), evidenceId && ((_a = sortedEvidence.find((evidence) => evidence.id === evidenceId)) == null ? void 0 : _a.component(investigation)));
}
export default Evidence;
